module.exports = __webpack_public_path__ + "media/images/fallback/google_email_social_icons-d4afd81d30c708d93907cb8ffc90b84f.png";